import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

import * as T from 'types'

import { getStateNameFromCode } from './locationHelpers'

dayjs.extend(isSameOrAfter)

const WARNING_STATES = ['WI', 'NJ', 'NC']

const WARNING_DATE_END = new Date('1/23/2023')

export const getWarningMessageDataForState = (stateCode?: string) => {
  const warningMessageEndDate = dayjs(WARNING_DATE_END).format('MM/DD/YYYY')
  const stateName = stateCode && getStateNameFromCode(stateCode)

  if (
    stateCode
    && WARNING_STATES.includes(stateCode)
    && dayjs(WARNING_DATE_END).isSameOrAfter(dayjs(Date.now()))
  ) {
    return {
      warningMessageIsActive: true,
      warningMessageEndDate,
      warningMessage: `Our prices will change in ${stateName} on ${warningMessageEndDate}. Complete your listing agreement by ${warningMessageEndDate} to take advantage of our current pricing.`,
    }
  }

  return {}
}

export const getPackage = (
  name: string,
  pricingPackages: T.IPricingPackage[] | undefined,
  stateCode?: string,
) => {
  if (!pricingPackages) return

  const isSameName = (pricingPackageName: string) =>
    pricingPackageName.toLowerCase() === name.toLowerCase()

  const isSameState = (stateCodes?: string[]) => stateCode && stateCodes?.includes(stateCode)

  const stateSpecificPackage = pricingPackages.find(
    pricingPackage => isSameName(pricingPackage.name) && isSameState(pricingPackage.stateCodes),
  )

  const defaultPackage = pricingPackages.find(pricingPackage => isSameName(pricingPackage.name))

  return stateSpecificPackage || defaultPackage
}

// will return the state based-package for each tier first, and then the default package if it doesn't exist
export const getPackagesForState = (allPricingPackages: T.IPricingPackage[], stateCode = '') => {
  const defaultPricingPackages = allPricingPackages.filter(
    pricingPackage => !pricingPackage.stateCodes || !pricingPackage.stateCodes.length,
  )

  // hack to make the default appear as 199 instead of 0 without changing the db data
  // possibly temporary
  const defaultBasic = defaultPricingPackages.find(pricingPackage => !pricingPackage.payNow)

  if (defaultBasic) {
    defaultBasic.payNow = 199
    defaultBasic.payAtClose = 400
  }
  // end hack

  const statePricingPackages = allPricingPackages.filter(pricingPackage =>
    pricingPackage.stateCodes?.includes(stateCode),
  )

  const pricingPackagesNamesSet = new Set(
    statePricingPackages.map(pricingPackage => pricingPackage.name),
  )

  const statePricingPackageSet = defaultPricingPackages.reduce((accum, defaultPricingPackage) => {
    if (!pricingPackagesNamesSet.has(defaultPricingPackage.name)) accum.push(defaultPricingPackage)

    return accum
  }, statePricingPackages)

  return statePricingPackageSet
}
